import { z } from 'zod';

export const AGENT_IDS = [
  'muse',
  'jack',
  'atlas',
  'jarius',
] as const;

export const AgentIdSchema = z.enum(AGENT_IDS);
export type AgentId = z.infer<typeof AgentIdSchema>;

export const AgentStatusSchema = z.enum([
  'idle',
  'working',
  'waiting',
  'blocked',
  'offline',
  'celebrating',
]);
export type AgentStatus = z.infer<typeof AgentStatusSchema>;

export const FreshnessSchema = z.enum(['fresh', 'stale', 'unknown']);

export const AgentStateSchema = z.object({
  agentId: AgentIdSchema,
  ts: z.string().datetime().optional(),
  status: AgentStatusSchema,
  activity: z.string().max(240).default('—'),
  progress: z.number().min(0).max(1).optional(),
  since: z.string().datetime().nullable().optional(),
  lastEventTs: z.string().datetime().optional(),
  kpis: z.record(z.string(), z.number()).optional(),
  meta: z
    .object({
      simulated: z.boolean().optional(),
      freshness: FreshnessSchema.optional(),
      lastUpstreamFetchAt: z.string().datetime().optional(),
    })
    .optional(),
});
export type AgentState = z.infer<typeof AgentStateSchema>;

export function offlineState(agentId: AgentId): AgentState {
  return {
    agentId,
    status: 'offline',
    activity: 'unreachable',
    since: null,
    meta: { freshness: 'unknown' },
  };
}
